import { createEnvelopeSource } from './create-envelope-source';

/**
 * Age-gating acquisition source. Pure config over the standardized envelope
 * (`GET /analytics/age-gating/acquisition`): `newUsers` / `ageGatedUsers` are
 * scalar counts, `ageGatedRate` is the ratio. All mapping/fetching lives in
 * `createEnvelopeSource`.
 *
 * `multiline` renders the `businessUnit` breakdown (#765) as one line per
 * region: `multilineRate` names the two count cells (`ageGatedUsers` over
 * `newUsers`) each row's legend divides.
 */
export const ageGatingSource = createEnvelopeSource({
    label: 'Age gating',
    endpoint: 'analytics/age-gating/acquisition',
    metrics: [
        { id: 'newUsers', label: 'New users', type: 'scalar' },
        { id: 'ageGatedUsers', label: 'Age-gated users', type: 'scalar' },
        { id: 'ageGatedRate', label: 'Age-gated rate', type: 'ratio' },
        {
            id: 'unverifiedNewUsers',
            label: 'Unverified new users',
            type: 'scalar',
            lowerIsBetter: true,
        },
    ],
    forms: ['number', 'rate', 'line', 'multiline'],
    regionGrain: 'province',
    multilineRate: {
        numeratorMetricId: 'ageGatedUsers',
        denominatorMetricId: 'newUsers',
    },
});
